import { render, staticRenderFns } from "./exhibition-history-form.vue?vue&type=template&id=66d73e60"
import script from "./exhibition-history-form.vue?vue&type=script&lang=js"
export * from "./exhibition-history-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports